import React, { useEffect, useState, useRef } from 'react';
import { Row, Col, Input, Button, Form, Spin, TimePicker } from 'antd';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import * as S from './styles.js';
import {
  getParametrosGerais,
  postParametrosGerais,
} from '../../../services/parametrosGerais.js';

export function ParamtrosGerenciamentoRisco() {
  const history = useHistory();
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const ref = useRef(null);
  const initialData = async () => {
    setLoader(true);
    const response = await getParametrosGerais();
    setData(response.data);
    return setLoader(false);
  };

  useEffect(() => {
    initialData();
  }, []);

  const styleLocal = {
    buttonStyle: {
      background: '#24A95D',
      borderColor: '#24A95D',
      width: '200px',
      height: '56px',
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      fontWeight: 'bold',
    },
    title: {
      margin: '16px 16px 34px 16px',
    },
    rows: {
      margin: '16px 16px 23px 16px',
      minHeight: '80px',
    },
  };

  const onFinish = async values => {
    const payload = {
      timeoutConsulta: values.timeoutConsulta,
      timeoutConsultaB: values.timeoutConsultaB,
      tempoCronometro: values.tempoCronometro,
      metaTempoMedioFila: moment(values.metaTempoMedioFila).format('HH:mm:ss'),
      metaTempoMedioFornecedor: moment(values.metaTempoMedioFornecedor).format(
        'HH:mm:ss'
      ),
      metaTempoMedioAtendimento: moment(
        values.metaTempoMedioAtendimento
      ).format('HH:mm:ss'),
      metaTempoMedioAnaliseTotal: moment(
        values.metaTempoMedioAnaliseTotal
      ).format('HH:mm:ss'),
    };
    setLoader(true);
    await postParametrosGerais({ payload });
    initialData();
    return setLoader(false);
  };

  const cancel = () => {
    initialData();
  };

  const [form] = Form.useForm();

  form.setFieldsValue({
    timeoutConsulta: data?.timeoutConsulta,
    timeoutConsultaB: data?.timeoutConsultaB,
    tempoCronometro: data?.tempoCronometro,
    metaTempoMedioFila: moment(data?.metaTempoMedioFila, 'HH:mm:ss'),
    metaTempoMedioFornecedor: moment(
      data?.metaTempoMedioFornecedor,
      'HH:mm:ss'
    ),
    metaTempoMedioAtendimento: moment(
      data?.metaTempoMedioAtendimento,
      'HH:mm:ss'
    ),
    metaTempoMedioAnaliseTotal: moment(
      data?.metaTempoMedioAnaliseTotal,
      'HH:mm:ss'
    ),
  });

  const InputsParam = () => {
    const dadosInput = [
      {
        label: 'Timeout de consulta - Em Minutos (A)',
        name: 'timeoutConsulta',
        type: 'number',
        masked: false,
        placeholder: 'Digite os Minutos',
      },
      {
        label: 'Timeout de consulta - Em Minutos (B)',
        name: 'timeoutConsultaB',
        type: 'number',
        masked: false,
        placeholder: 'Digite os Minutos',
      },
      {
        label: 'Tempo do cronômetro (Atendimento) - Em Minutos',
        name: 'tempoCronometro',
        type: 'number',
        masked: false,
        placeholder: 'Digite os Minutos',
      },
      {
        label: 'Meta de tempo médio de fila.',
        name: 'metaTempoMedioFila',
        type: 'text',
        masked: true,
        placeholder: 'Digite as horas, Minutos e segundos.',
      },
      {
        label: 'Meta de tempo médio de Fornecedor.',
        name: 'metaTempoMedioFornecedor',
        type: 'text',
        masked: true,
        placeholder: 'Digite as horas, Minutos e segundos.',
      },
      {
        label: 'Meta de tempo médio de atendimento.',
        name: 'metaTempoMedioAtendimento',
        type: 'text',
        masked: true,
        placeholder: 'Digite as horas, Minutos e segundos.',
      },
      {
        label: 'Meta de tempo médio de análise total.',
        name: 'metaTempoMedioAnaliseTotal',
        type: 'text',
        masked: true,
        placeholder: 'Digite as horas, Minutos e segundos.',
      },
    ];
    return dadosInput.map(objeto => (
      <Form.Item label={objeto.label} name={objeto.name}>
        {objeto.masked ? (
          <TimePicker
            showNow={false}
            style={{ width: '140px', borderRadius: 'none' }}
            defaultOpenValue={moment('00:00:00', 'HH:mm:ss')}
          />
        ) : (
          <Input
            ref={ref}
            type={objeto.type}
            placeholder={objeto.placeholder}
            style={{ width: '140px', borderRadius: 'unset' }}
          />
        )}
      </Form.Item>
    ));
  };

  return (
    <Spin
      spinning={loader}
      size="large"
      style={{
          width: '100%',
        }}
      tip="Carregando dados de Parâmetros"
      delay={200}
    >
        <S.BlocoPar style={styleLocal.title}>
          <Col
            span={24}
            justify="space-between"
            align="middle"
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <S.TextTitle>Parâmetros Gerais</S.TextTitle>
            <Button
              style={styleLocal.buttonStyle}
              type="primary"
              size="large"
              onClick={() => history.push('/painel-de-controle')}
            >
              Voltar
            </Button>
          </Col>
        </S.BlocoPar>
        <S.BlocoPar style={styleLocal.title}>
          <Row span={24} style={{ width: '100%' }} justify="center">
            <Form
              form={form}
              layout="vertical"
              style={{ width: '100%' }}
              onFinish={onFinish}
            >
              <Col justify="start" span="6">
                <InputsParam />
              </Col>
              <Form.Item span={24}>
                <Row justify="center">
                  <S.StyledButtonCancel
                    type="primary"
                    htmlType="button"
                    onClick={() => cancel()}
                  >
                    Cancelar
                  </S.StyledButtonCancel>
                  <S.StyledButton type="primary" htmlType="submit">
                    Salvar
                  </S.StyledButton>
                </Row>
              </Form.Item>
            </Form>
          </Row>
        </S.BlocoPar>
    </Spin>
  );
}
